






import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconNavigation extends Vue {
    @Prop({ type: Number, default: 28 }) readonly size!: number
    @Prop({ type: Boolean, default: false }) readonly right!: boolean
    @Prop({ type: Boolean, default: true }) readonly left!: boolean
    @Prop({ type: Boolean, default: false }) readonly up!: boolean
    @Prop({ type: Boolean, default: false }) readonly down!: boolean


    get componentClass() {
        return {
            right: this.right,
            up: this.up,
            down: this.down,
        }
    }
}
